var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83342 0.500122L9.16676 12.5001M0.500092 9.83346L6.50009 6.50012M3.70009 12.5001H9.30009C10.4202 12.5001 10.9802 12.5001 11.4081 12.2821C11.7844 12.0904 12.0904 11.7844 12.2821 11.4081C12.5001 10.9803 12.5001 10.4202 12.5001 9.30012V3.70012C12.5001 2.58002 12.5001 2.01996 12.2821 1.59214C12.0904 1.21582 11.7844 0.909856 11.4081 0.718109C10.9802 0.500122 10.4202 0.500122 9.30009 0.500122H3.70009C2.57999 0.500122 2.01993 0.500122 1.59211 0.718109C1.21579 0.909856 0.909825 1.21582 0.718079 1.59214C0.500092 2.01996 0.500092 2.58002 0.500092 3.70012V9.30012C0.500092 10.4202 0.500092 10.9803 0.718079 11.4081C0.909825 11.7844 1.21579 12.0904 1.59211 12.2821C2.01993 12.5001 2.57999 12.5001 3.70009 12.5001Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2538e3dedcc389e8d5d5bf6b68a9507e.svg";
export { ForwardRef as ReactComponent };